import styled from "@emotion/styled";
import { Trans } from "react-i18next";
import { useModals } from "src/components/Modals/context/ModalProvider";
import { ModalsNames } from "src/components/Modals/context/modals";
import CommentAnswerIcon from "src/images/Icons/newIcons/notifications/commentAnswer.svg";

import { TimeComponent } from "../../NewComponents/Default/TimeComponent";
import type { NotificationData } from "./List";
import { Notification } from "./NotificationItem";

interface CommentAnswerProps {
	notification: NotificationData;
	removeNotification: () => Promise<unknown>;
	className?: string;
}

function CommentAnswer({
	notification,
	removeNotification,
	className,
}: CommentAnswerProps) {
	const { openModal } = useModals();

	const redirect = async () => {
		openModal(ModalsNames.QuestionViewModal, {
			questionId: notification.itemId,
			settings: {
				comments: notification.itemId,
			},
		});
	};

	return (
		<Notification
			className={className}
			notification={notification}
			removeNotification={removeNotification}
			onRedirect={redirect}
			Icon={CommentAnswerIcon}
			Primary={
				<Trans
					i18nKey="notifications.commentAnswer.title"
					values={{ username: notification.username }}
					components={[<strong className="text-black" key="i18Key" />]}
				/>
			}
			Secondary={
				<div className="text-primary size-12 mt-2">
					<TimeComponent
						date={notification.createdAt}
						transKey="notifications.comment.days"
					/>
				</div>
			}
		/>
	);
}

export const CommentAnswerNotification = styled(CommentAnswer)``;
